import { useEffect, useState } from 'react';
import axios from 'axios';
import { Navigate, useLocation } from 'react-router-dom';
import { baseURL } from '../AxiosConfig';
import { brandingEstabId } from '../branding';
import LoginPage from '../login/Login';

// Fallback publico: na raiz de um deployment com estabelecimento, abre a pagina dele; sem pagina, mostra o login.
export default function BrandingHome() {
    const { pathname } = useLocation();
    const isRoot = pathname === '/';
    const [slug, setSlug] = useState<string | null>(isRoot && brandingEstabId ? null : '');

    useEffect(() => {
        if (slug !== null) return;
        const controller = new AbortController();
        axios.get<{ slug: string }>(`${baseURL}/landing-page/slug`, { params: { estabId: brandingEstabId }, signal: controller.signal })
            .then(({ data }) => setSlug(data?.slug || ''))
            .catch(() => { if (!controller.signal.aborted) setSlug(''); });
        return () => controller.abort();
    }, [slug]);

    if (slug === null) {
        return (
            <div className="grid min-h-screen place-items-center bg-base-200" role="status">
                <span className="loading loading-spinner loading-md text-base-content/40" aria-label="Carregando estabelecimento"></span>
            </div>
        );
    }
    if (slug) return <Navigate to={`/page/${encodeURIComponent(slug)}`} replace />;
    return <LoginPage />;
}
